/**
 * Componente de Callback de Autenticação
 * Trata redirecionamentos de callback OAuth - independente de provedor
 * O tratamento real do redirecionamento é feito pelo AuthProvider durante a inicialização
 * Verifica role via /auth/me antes de redirecionar ao dashboard (403 ROLE_NOT_ALLOWED → /access-denied)
 */
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth';
import { httpClient } from '@/shared/lib/httpClient';

export function AuthCallback() {
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  const isVerifyingRoleRef = useRef(false);

  useEffect(() => {
    if (!isLoading && isAuthenticated && !isVerifyingRoleRef.current) {
      isVerifyingRoleRef.current = true;
      httpClient
        .get<{ id: string; email: string }>('/auth/me')
        .then(() => {
          navigate('/dashboard', { replace: true });
        })
        .catch((err) => {
          // 403 ROLE_NOT_ALLOWED: httpClient já redireciona para /access-denied
          const isRoleDenied = err instanceof Error && err.message.includes('Acesso negado');
          if (!isRoleDenied) {
            navigate('/login', { replace: true });
          }
        })
        .finally(() => {
          isVerifyingRoleRef.current = false;
        });
    } else if (!isLoading && !isAuthenticated) {
      navigate('/login', { replace: true });
    }
  }, [isLoading, isAuthenticated, navigate]);

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="flex items-center space-x-2">
        <span className="h-8 w-8 animate-spin rounded-full border-4 border-visagio-mint border-t-transparent"></span>
        <span className="text-lg">Processando autenticação...</span>
      </div>
    </div>
  );
}
